export default __webpack_public_path__ + "static/media/dele_active.823bb2f1.svg";